import { ENCOUNTER_POLLING_INTERVAL_MS } from '../config';

type EncounterPoll = {
  followers: number;
  timer: number | null;
};

// One poller per encounter, however many views follow it: the recording
// page, its corner window and the live session read the same encounter.
const polls: Record<string, EncounterPoll> = {};

const schedule = (
  encounterId: string,
  poll: EncounterPoll,
  read: () => Promise<unknown>,
) => {
  poll.timer = window.setTimeout(() => {
    poll.timer = null;
    void read().finally(() => {
      if (polls[encounterId] === poll) {
        schedule(encounterId, poll, read);
      }
    });
  }, ENCOUNTER_POLLING_INTERVAL_MS);
};

// The next read starts only after the previous one answered. Returns the
// call that stops following; the last one stops the poller.
export const followEncounter = ({
  encounterId,
  read,
}: {
  encounterId: string;
  read: () => Promise<unknown>;
}) => {
  const poll = polls[encounterId] ?? { followers: 0, timer: null };
  poll.followers += 1;
  if (!polls[encounterId]) {
    polls[encounterId] = poll;
    schedule(encounterId, poll, read);
  }

  const following = { active: true };
  return () => {
    if (!following.active) {
      return;
    }
    following.active = false;
    poll.followers -= 1;
    if (poll.followers > 0) {
      return;
    }
    if (poll.timer !== null) {
      window.clearTimeout(poll.timer);
    }
    delete polls[encounterId];
  };
};
